<template>
  <div class="container">
    <h3 class="text-center">Compound Interest Calculator</h3>
    <form @submit.prevent="formSubmitted">
      <div class="input-group mb-3">
        <div class="input-group-prepend calc-label">
          <span class="input-group-text">Current Principal</span>
        </div>
        <input v-model.number="currentPrincipal" type="decimal" class="form-control" required>
      </div>
      <div class="input-group mb-3">
        <div class="input-group-prepend calc-label">
          <span class="input-group-text">Annual Addition</span>
        </div>
        <input v-model.number="annualAddition" type="decimal" class="form-control" required>
      </div>
      <div class="input-group mb-3">
        <div class="input-group-prepend calc-label">
          <span class="input-group-text">Years to Grow</span>
        </div>
        <input v-model.number="yearsToGrow" type="number" class="form-control" required>
      </div>
      <div class="input-group mb-3">
        <div class="input-group-prepend calc-label">
          <span class="input-group-text">Interest Rate</span>
        </div>
        <input v-model.number="interestRate" type="decimal" class="form-control" required>
      </div>
      <div class="input-group mb-3">
        <div class="input-group-prepend calc-label">
          <span class="input-group-text">Annual compounds</span>
        </div>
        <input v-model.number="annualCompounds" type="number" class="form-control" required>
      </div>
      <div class="input-group mb-3">
        <div class="input-group-prepend calc-label">
          <button @click="formSubmitted" type="submit" class="btn btn-primary">Calculate</button>
        </div>
        <div class="input-group-prepend">
          <span class="input-group-text">$</span>
        </div>
        <input v-model="endResult" type="text" class="form-control" disabled>
      </div>
    </form>
    <div class="clear-button text-center">
      <button @click="clearForm" type="submit" class="btn btn-danger">Clear</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    currentPrincipal: '',
    annualAddition: '',
    yearsToGrow: '',
    interestRate: '',
    annualCompounds: 1.0,
    endResult: '',
  }),
  methods: {
    formSubmitted() {
      if (this.currentPrincipal !== '' && this.annualAddition !== ''
          && this.yearsToGrow !== '' && this.interestRate !== '' && this.annualCompounds) {
        let currentAmount = this.currentPrincipal;
        for (let i = 0; i < this.yearsToGrow; i += 1) {
          currentAmount += this.annualAddition;
          currentAmount *= ((1 + (this.interestRate / 100 / this.annualCompounds))
            ** (this.annualCompounds));
        }
        this.endResult = currentAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    },
    clearForm() {
      this.currentPrincipal = '';
      this.annualAddition = '';
      this.yearsToGrow = '';
      this.interestRate = '';
      this.annualCompounds = 1.0;
      this.endResult = '';
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Poppins:400|Poppins:400');
.calc-label {
  width: 40%;
  min-width: 175px;
  margin-right: 5px;
}
.input-group-text {
  width: 100%;
}
.btn-primary {
  width: 100%;
}
h3 {
  color: white;
  margin: 16px 0px;
}
body {
  background: black;
  font-family: 'Poppins', sans-serif;
}
.clear-button {
  margin: 75px 0 0 0;
}

@media (min-width: 500px) {
  .container{
      max-width: 500px;
  }
}
</style>
